import { useEffect, useRef } from 'react'
import { useBaiduMap } from './BaiduMap'

export interface BaiduPolylineProps {
    path: { lat: number; lng: number }[]
    options?: {
        strokeColor?: string
        strokeOpacity?: number
        strokeWeight?: number
    }
}

const BaiduPolyline: React.FC<BaiduPolylineProps> = ({ path, options }) => {
    const map = useBaiduMap()
    const polylineRef = useRef<any>(null)

    useEffect(() => {
        if (!map || !window.BMapGL || path.length < 2) return

        const points = path.map(p => new window.BMapGL.Point(p.lng, p.lat))
        const polyline = new window.BMapGL.Polyline(points, {
            strokeColor: options?.strokeColor || '#2563eb',
            strokeWeight: options?.strokeWeight ?? 3,
            strokeOpacity: options?.strokeOpacity ?? 0.8,
        })

        map.addOverlay(polyline)
        polylineRef.current = polyline

        return () => {
            map.removeOverlay(polyline)
            polylineRef.current = null
        }
    }, [map, JSON.stringify(path), options?.strokeColor, options?.strokeWeight, options?.strokeOpacity])

    return null
}

export default BaiduPolyline
